export * from './trimAndSingleSpace.module';
export * from './trimAndSingleSpace.directive';
